/** Where a CustomTask entry takes its address from. */
export enum TimeCardEntryLocationSourceType {
  ACCOUNT = 'ACCOUNT',
  SERVICE_POINT = 'SERVICE_POINT',
  CUSTOM = 'CUSTOM'
}
